module.exports = __webpack_public_path__ + "img/Imagen 3.f798cf74.jpg";